module.exports = __webpack_public_path__ + "img/03.d4a8034d.png";